import http from './http'

// 获取列表
export function pageList (queryString) {
  return http.get(`/client/user/score/record?${queryString}`)
}
